import LastUpdatedStatus from './component.jsx'

export default LastUpdatedStatus
